export default __webpack_public_path__ + "static/media/route.6c3d5a8c.jpg";